import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "20.1 0 259.8 300",
	...props,
	children: [/* @__PURE__ */ _jsx("polygon", {
		fill: "#fff",
		points: "20.1 75 20.1 225 150 300 279.9 225 279.9 75 150 0 20.1 75"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M180.50402,165.99136c2.08008-1.44995,3.43994-3.84009,3.43994-6.57007v-24.03992c0-4.43005-3.57983-8.01001-8.01001-8.01001-4.42993,0-8.01001,3.57996-8.01001,8.01001v17.33997c2.65015.79004,5.12012,2.17004,7.2002,4.09009,2.77979,2.54993,4.56982,5.76001,5.37988,9.17993Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M155.90392,153.32144v-33.96008c0-4.44006-3.57983-8.02002-8.02002-8.02002-4.42993,0-8.00977,3.57996-8.00977,8.02002v40.05994c0,2.68005,1.31982,5.06006,3.33984,6.52002h.01001c1.72998-2.83997,3.76001-5.53003,6.05005-8.03003,1.85986-2.0199,4.12988-3.57996,6.62988-4.58984Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M211.99401,152.02139v-48.69006c0-4.43005-3.59009-8.00989-8.02002-8.00989s-8.01001,3.57983-8.01001,8.00989v56.08997c0,.12012,0,.22998.01001.34009.75-1.05005,1.61011-2.04004,2.6001-2.94995,3.38989-3.12012,7.79004-4.83008,12.37988-4.83008.3501,0,.69995.01001,1.04004.04004Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M103.82409,183.46133c-2.20996,0-4.01001-1.81006-4.01001-4.01001v-84.12988c0-4.43005-3.58008-8.01001-8.01001-8.01001-4.43994,0-8.02002,3.57996-8.02002,8.01001v84.12988c0,11.07007,8.96997,20.03003,20.04004,20.03003h32.02002c-.23999-2.03003-.36011-4.08008-.36011-6.14001,0-3.34998.32007-6.65002.93994-9.88h-32.59985Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M119.84484,167.43325c4.43164,0,8.01245-3.58057,8.01245-8.01245v-16.02502c0-4.43201-3.58081-8.01257-8.01245-8.01257-4.43213,0-8.0127,3.58057-8.0127,8.01257v16.02502c0,4.43188,3.58057,8.01245,8.0127,8.01245Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M186.84948,181.64968c-6.44165,0-11.68262,5.2406-11.68262,11.68225s5.24097,11.68262,11.68262,11.68262,11.68237-5.24084,11.68237-11.68262-5.24072-11.68225-11.68237-11.68225Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M167.03722,165.64443c-1.15723-1.07324-2.6665-1.66455-4.25024-1.66431-1.61914,0-3.18457.62817-4.35571,1.7356h-.0437l-.27075.29517c-6.85474,7.47583-10.62988,17.17871-10.62988,27.32104s3.77515,19.84546,10.63037,27.32202c1.1897,1.29529,2.87598,2.03809,4.62646,2.03809,1.57959,0,3.09546-.59277,4.26758-1.66919,2.55347-2.34521,2.71899-6.33496.36914-8.89355-4.70801-5.13599-7.30103-11.81189-7.30103-18.79736,0-6.99402,2.60034-13.66907,7.32324-18.79663,2.33813-2.5459,2.17432-6.5343-.36548-8.89087Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#304050",
			d: "M215.5819,166.01089l-.27075-.29517h-.0437c-1.17114-1.10742-2.73657-1.7356-4.35571-1.7356-1.58398-.00024-3.09302.59106-4.25,1.66431-2.54004,2.35657-2.70386,6.34497-.36572,8.89087,4.7229,5.12756,7.32324,11.80261,7.32324,18.79663,0,6.98547-2.59302,13.66138-7.30127,18.79736-2.34961,2.55859-2.18408,6.54834.36938,8.89355,1.17212,1.07642,2.68774,1.66919,4.26758,1.66919,1.75024,0,3.43677-.7428,4.62646-2.03809,6.85522-7.47656,10.63037-17.17932,10.63037-27.32202s-3.77515-19.84521-10.62988-27.32104Z"
		})
	] })]
});
export default SvgLogo;
